// Webpack CSS import
import 'onsenui/css/onsenui.css';
import 'onsenui/css/onsen-css-components.css';
import './global.scss';

import Vue from 'vue';
import Vuex from 'vuex';
const VueOnsen = require('vue-onsenui'); // This imports 'onsenui', so no need to import it separately
import App from './App.vue';
import router from './router';
import storeLike from './store';
import axios from 'axios';
axios.defaults.baseURL = `https://phoneservices.core.mytelnet.co.za`;
// axios.defaults.baseURL = `http://localhost:3000`;
axios.interceptors.request.use(
    (config) => {
        config.headers.common.Authorization = `Bearer ${localStorage.getItem('app:ACCESS_TOKEN')}`;
        return config;
    },
    (err: any) => {
        return Promise.reject(err);
    }
);
axios.interceptors.response.use(
    response => response,
    error => {
        const originalRequest = error.config;
        if (error.response && error.response.status === 401) {
            let username = localStorage.getItem('app:USERNAME');
            let password = localStorage.getItem('app:PASSWORD');
            let domain = localStorage.getItem('app:DOMAIN');

            if (username && password && domain) {
                username = atob(username);
                password = atob(password);
                domain = atob(domain);
            } else {
                return Promise.reject();
            }
            const url = `/token?domain=${domain}&username=${username}&password=${password}`;
            return axios.get(url)
                .then(res => {
                    localStorage.setItem('app:ACCESS_TOKEN', res.data);
                    axios.defaults.headers.Authorization = `Bearer ${res.data}`;
                    originalRequest.headers.Authorization = `Bearer ${res.data}`;
                    return axios(originalRequest);
                }).catch(err => {
                    console.log(err);
                });
        }
        return Promise.reject(error);
    }
);
Vue.prototype.$http = axios;
Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(VueOnsen); // VueOnsen set here as plugin to VUE.

new Vue({
    router,
    render: h => h(App),
    store: new Vuex.Store(storeLike),
    beforeCreate() {
        // Shortcut for Material Design
        Vue.prototype.md = true;

        // Set iPhoneX flag based on URL
        if (window.location.search.match(/iphonex/i)) {
            document.documentElement.setAttribute('onsflag-iphonex-portrait', '');
            document.documentElement.setAttribute('onsflag-iphonex-landscape', '');
        }
    },
}).$mount('#app');
